import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import PendingDocumentsPopup from '../components/PendingDocumentsPopup';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';

function PendingDocumentList() {

    const navigate = useNavigate();
    const [pendingListing, setPendingListing] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState([]);

    useEffect(() => {
        const fetchPendingListing = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            const formData = new FormData();
            formData.append('token', hostData.host_access_token);
          
            let allListings = [];
            let page = 1;
            let totalPages = 1;
          
            setLoading(true);
          
            try {
              while (page <= totalPages) {
                const url = `${params.baseURL}${params.endpoints.getPendingListings}?page=${page}`;
                const response = await axios({
                  method: 'post',
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  },
                  url,
                  data: formData
                });
          
                if (response.data.items && Array.isArray(response.data.items)) {
                  allListings = [...allListings, ...response.data.items];
                  totalPages = response.data._meta?.pageCount || 1;
                  page += 1;
                } else {
                  break;
                }
              }
          
              setPendingListing(allListings);
            } catch (err) {
              setError(err.message || 'Error fetching pending listings');
            } finally {
              setLoading(false);
            }
          };          
      
          fetchPendingListing();
    }, []); 

    const handlePendingListClick = (data) => {
        setSelectedDocuments(data);
        navigate('/listing-document-verification', { state: { data } });
    };   

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading category: {error.message}</p>;
    }

    return (
        <div>
          <Helmet>
            <title>Pending Document List</title>
            <meta name="description" content="" />
          </Helmet>

          <div className='pending-listing-box'>
            {pendingListing.length > 0 ? (
                <>
                <div className='plbald'>
                    {pendingListing.map((data) => (
                        <div className='pldata-box' key={data.stay_listing_id} onClick={() => handlePendingListClick(data)}>
                            <div className='pldata-info-box'>
                                <div className='category-img-section'>
                                    <img className='img-fluid ciso'  
                                        src={data.cover_photo ? data.cover_photo : '/assets/img/default_listing.jpg'}
                                        alt='' 
                                    />
                                    <img src={data.category_info.category_image_url} alt='' className='cist' />
                                </div>
                                <div className='pltxt-box'>
                                    <div className='cat-pointer'>
                                        <img src={data.property_title_icon_image} alt="Profile" className="pointer-icon" />
                                        <div className='wspl-ta-section' style={{width:'300px'}}>
                                            <span className='wspl-title-box'>{data.listing_title || 'Unknown Title'}</span>
                                            <span className='wspl-add-box'>{data.property_address}</span>
                                        </div>
                                    </div>
                                    {/*<div className='cat-pointer'>
                                        <img src={'/assets/img/icons/pointer_icon.svg'} alt="Profile" className="pointer-icon" />
                                        <span><strong>Verify Owner's identity</strong></span>
                                    </div>*/}
                                    <div className='catp-box'>
                                        <div className='cat-pointer mb-0'>
                                            <img src={'/assets/img/icons/pending_verification_icon.svg'} alt="Profile" className="pointer-icon" />
                                            <span className='plpvrtb'>Pending: Verify Owner's identity</span>
                                        </div>
                                        <div>
                                            <i class="fas fa-chevron-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                </>
            ) : (
                <></>
            )}
          </div>

          <PendingDocumentsPopup 
              show={showPopup} 
              onClose={() => setShowPopup(false)} 
              data={selectedDocuments} 
          />

        </div>
    );
}

export default PendingDocumentList;